<script setup lang="ts">
import AuthUserButton from "@/components/AuthUserButton.vue";
import SuspenseRouterView from "@/components/SuspenseRouterView.vue";
import { useAuth } from "@/constants/plugins/auth";

const auth = useAuth();
</script>

<template>
  <div class="flex h-screen max-h-screen min-h-screen w-full overflow-hidden">
    <main
      :class="{
        ['flex flex-1 flex-col overflow-y-auto']: true,
      }"
    >
      <slot><SuspenseRouterView /></slot>

      <div v-if="auth.isAuthenticated" class="fixed bottom-8 left-8 lg:w-60">
        <AuthUserButton />
      </div>
    </main>
  </div>
</template>
